import React from "react";
import "./education.css";
const index = () => {
  return (
    <div className="educationContainer">
      <h2 className="educationHeading">Learning</h2>
      <div className="titleUnderline"></div>
      <h1 className="educationHeading2">My Education</h1>
      <div className="educationItems">
        <div className="educationItem1">
          <div className="educationCircle1">
            <div className="date reactColor educationClass">2018</div>
          </div>
          <div className="experienceContent educationContents">
          <h2>Technical SLC</h2>
            <span className="subTitile reactColor">Shree Pokhariya Secondary School</span>
          </div>
        </div>
        <div className="educationItem2">
          <div className="educationCircle2">
            <div className="date webColor educationClass">2021</div>
          </div>
          <div className="experienceContent educationContents">
          <h2>
              Diploma In Computer Engineering
            </h2>
            <span className="subTitile webColor">Shree Pokhariya Secondary School</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default index;
